import { WebfeederModuleEnum, WebfeederServiceEnum } from "../enums/webfeeder";

export class MessageWebFeeder {
  token?: string;
  module?: WebfeederModuleEnum;
  service?: WebfeederServiceEnum;
  parameterGet?: string;
  parameters: any;
}

export class MessageParameterQuote {
  subsbribetype?: string;
  filter?: string;
  delay?: string;
  quantidade?: string;
  typecommand?: string;
}
